export const headBody6 = {
    "bone_controllers": [
        {
            "name": "legs_length_long",
            "value": 0.4
        },
        {
            "name": "waist_length_long",
            "value": 0.3
        },
        {
            "name": "neck_length_long",
            "value": 0.1
        },
        {
            "name": "head_size_small",
            "value": 0.3
        },
        {
            "name": "arms_length_long",
            "value": 0.3
        },
        {
            "name": "waist_thickness_thick",
            "value": 0.35
        },
        {
            "name": "arms_thickness_thick",
            "value": 0.15
        },
        {
            "name": "legs_thickness_thick",
            "value": 0.2
        }
    ],
}